<template>
  <section id="mainContainer">
    <userHeader></userHeader>
    <section class="mid-container">
      <section class="page-banner-section" :style="{ 'background-image': `url(${getCdnImageAddress(articleData.articleImage, `w_1028,h_290/`)})` }">
        <div class="container">
          <h1 v-if="articleData">{{ articleData.title }}</h1>
        </div>
      </section>
      <section class="article-details-page">
        <div class="container">
          <div class="article-details-content">
            <p v-html="articleData.description"></p>
          </div>
        </div>
      </section>
      <!-- <div class="date-filter-box" id="dateFilterDropdown" :class="{ 'show-date-dropdown': showDateDropdown }">
        <div class="date-filter-icon">
          <button id="dateFilterBtn" @click="showDateDropdown = true"><img src="@/assets/images/admin-img/date-blue.svg" alt="" /></button>
        </div>
        <div class="date-filter-dropdown" :class="{ 'show-custom-date': showCustomDate }">
          <div class="date-filter-dropdown-in">
            <a href="#" id="lastWeeekLink" class="date-item">week</a>
            <a href="#" id="lastMonthLink" class="date-item">month</a>
            <a href="#" id="customDateLink" @click.prevent="showCustomPicker = true; showCustomDate = true">custom</a>
          </div>
          <div class="custom-date-picker">
            <Datepicker
              v-if="showCustomPicker"
              range
              :enable-time-picker="false"
              :clearable="false"
              menu-class-name="custom-datepicker-menu"
              :inline="true" 
              @range-start="onRangeStart"
              @range-end="onRangeEnd"
             >
              <template #action-buttons>
                <div class="action-buttons">
                  <button class="apply-btn" @click="handleDate()">Apply</button>
                  <button id="cancelButton" class="cancel-btn" @click="resetClasses">Cancel</button>
                </div>
              </template>
</Datepicker>
</div>
</div>
</div> -->
    </section>
    <userFooter></userFooter>
    <ChatbotPopup></ChatbotPopup>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import userHeader from "@/components/userHeader.vue";
import axios from 'axios';
import { useRoute } from 'vue-router';
import userFooter from "@/components/userFooter.vue";
import { environment } from '@/config/environment';
// import Datepicker from '@vuepic/vue-datepicker';
// import '@vuepic/vue-datepicker/dist/main.css';
import { API_BASE_URL } from '@/config/api.config';
import ChatbotPopup from '@/components/chatbotPopup.vue';


export default defineComponent({
  name: "readMoreArticle",
  components: {
    userHeader,
    userFooter,
    ChatbotPopup
    // Datepicker
  },
  data() {
    return {
      articleSlug: '',
      articleData: {
        articleImage: '',
        title: '',
        description: '',
        slug: '',
      },
      // showCustomPicker: false,
      // showDateDropdown: false,
      // showCustomDate: false,
      // date:[] as Date[]
    };
  },
  methods: {
    // handleDate(){
    //   console.log(this.date)

    // },
    // onRangeStart(value:any){
    //   console.log(value)
    //   this.date[0]=value

    // },
    // onRangeEnd(value:any){
    //   console.log(value)
    //   this.date[1]=value

    // },

    async fetchArticleData() {
      try {
        const response = await axios.get(`${API_BASE_URL}/article/${this.articleSlug}/`);
        this.articleData = response.data;
      } catch (err) {
        console.error(err);
      }
    },
    getCdnImageAddress(src: string, size: string): string {
        if (!src) return '';
        let cdnUrl: string = environment.imageCdn.getHost;
        cdnUrl = cdnUrl.concat(size);
        return cdnUrl + encodeURIComponent(src);
    },
    // resetClasses() {
    //   this.showCustomPicker = false;
    //   this.showDateDropdown = false;
    //   this.showCustomDate = false;
    // },
  },
  mounted() {
    const route = useRoute();
    this.articleSlug = route.params.slug as string;
    if (this.articleSlug) {
      this.fetchArticleData();
    } else {
      console.error(Error);
    }
  }
});
</script>
